import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'rms-close-button',
  imports: [MatIconModule, MatIconButton],
  template: `
    <button
      class="{{ sizeMap[size] }} cursor-pointer"
      mat-icon-button>
      <mat-icon svgIcon="remix:System/close-line" />
    </button>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CloseButtonComponent {
  @Input() public size: 'sm' | 'md' | 'lg' = 'md';

  public sizeMap = {
    sm: 'w-10 h-10',
    md: 'w-12 h-12',
    lg: 'w-14 h-14',
  };
}
